import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { formatDate } from '../../utility';
import { HomeService } from '../../home/home.service';
import { GroupService } from '../../admin/groups/group.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../api.service';
import { HttpService } from '../services/http.service';
import { environment } from '../../../environments/environment';
import { SidebarService } from '../services/sidebar.service';
import { HelperService } from '../services/helper.service';

interface Theme {
  theme_id: string;
  value: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @Output() dropdownSelection = new EventEmitter<any>();
  @Output() dependeciesSelection = new EventEmitter<any>();
  @Output() myTaskSelection = new EventEmitter<any>();
  @Output() outcomeSelection = new EventEmitter<any>();
  @Output() progressDashboardSelection = new EventEmitter<any>();

  @Output() homeSelection = new EventEmitter<any>();
  groupListItem: any[];

  selectedDropdownOption: any;
  private homeService = inject(HomeService);
  private groupService = inject(GroupService);
  public sidebarService = inject(SidebarService);
  public helper = inject(HelperService);
  private apiService = inject(ApiService);
  @Input() type: any;

  // outcome data passing
  @Input() selectOutcomeSubGroupsData: any[] = [];
  @Input() outcomeListParentGroup: any[] = [];
  @Input() outcomeTeamMembers: any[] = [];
  @Output() onOutcomeTeamberSearch = new EventEmitter<any>();
  @Output() onelectOutcomeSubGroupsData = new EventEmitter<any>();

  // progress Dashbaord
  @Input() progressDashTeamMembers:any
@Input() selectProgressDashSubGroupsData:any
@Input() progressDashboardListParentGroup:any
@Output() onProgressTeamMemeber = new EventEmitter<any>();


  //wp dashboard
  @Output() wpDashboardTeamMembers = new EventEmitter<any>();
  
  
  @Input() businessThemeLists: Theme[] = [];
  @Input() isTask: boolean = false;
  @Input() isWpDashboard: boolean = false;
  @Input() isHomeSidebar: boolean = false;
  @Input() isOutcome: boolean = false;
  @Input() isDependecies: boolean = false;
  @Input() teamMembersLists: any = [];
  @Input() userTypeLists: any = [];
  @Input() statusLists: any = [];
  @Input() brandLists: any = [];
  @Input() isWPSidebar: boolean = false;
  @Input() theme: any; // Adjust the type as needed
  @Input() quarterShow: boolean = false;
  @Input() teamShow: boolean = false;
  @Input() themeShow: boolean = false;
  @Input() groupShow: boolean = false;
  @Input() usertypeShow: boolean = false;
  @Input() statusShow: boolean = false;
  @Input() brandShow: boolean = false;
  @Input() areaShow: boolean = false;
  @Input() indicationShow: boolean = false;
  @Input() isDashboard: boolean = false;

  @Input() quarter: any = [];

  brandListSubs!: Subscription;
  themeListSubs!: Subscription;
  memberListSubs!: Subscription;
  wpListSubs!: Subscription;
  private roleSubscription: Subscription;
  private quaterSubscription: Subscription;
  private themeSubscription: Subscription;
  untouchedAnnualOutcomes!: string;
  therapeuticAreaLists: any = [];
  IndicationLists: any[];
  selectedQuater: any;
  currentTheme: any;
  currentYear: any = new Date().getFullYear();
  httpService = inject(HttpService);

  rolesData: any = [
    {
      label: 'Owner',
      name: 'owners',
    },
    {
      label: 'Member',
      name: 'members',
    },
    {
      label: 'Manager',
      name: 'managers',
    },
    {
      label: 'User',
      name: 'users',
    },
  ];

  TypesOfWork: any = [
    { key: 'foundational-work', label: 'Foundational Work' },
    { key: 'ad-hoc', label: 'Ad-hoc' },
    { key: 'work-package', label: 'Work Package' },
    { key: 'chapter-work-package', label: 'Chapter Work Package' },
    { key: 'untagged', label: 'Untagged' },
  ];

  taskLists: any = [
    {
      key: '1',
      value: 'Not Started',
    },
    {
      key: '2',
      value: 'Ongoing',
    },
    {
      key: '3',
      value: 'Completed',
    },
    {
      key: '4',
      value: 'Delayed',
    },
    {
      key: '5',
      value: 'Terminated',
    },
  ];

  dependenciesData: any = {
    quarter: '',
  };
  loading: boolean = false;
  overAllGroups: any;
  overAllGroupsSubs: Subscription;
  parentStandaloneGroupListData: any = [];
  selectSubGroupsData: any = [];
  parentIds: any;
  progressDashboardParentId: any = null;
  progressDashboardSubGroupId: any = null;
  progressDashboardGroupIds: any = [];
  teamMembersData: any = [];
  allGroupsData: any;
  outcomeYear: { key: number; value: number }[];
  subParentId: any;
  selectSubGroupsOutcomeData: any[];

  onWPThemeSearch(event: any): void {
    const searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/member/themes`;

    this.sidebarService.performSearch(url, { search: searchTerm }).subscribe({
      next: (data: any) => {
        this.businessThemeLists = data || [];
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
      },
    });
  }

  onParentStandaloneGroupSearch(event?: any) {
    const searchTerm = event?.filter || '';
    const url = `${environment.opbBackendHost}/api/${this.selectedRole}/parent/groups`;

    this.sidebarService.performSearch(url, { search: searchTerm }).subscribe({
      next: (data: any) => {
        this.parentStandaloneGroupListData = data || [];
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
      },
    });
  }

  onWPTeamSearch(event: any): void {
    const searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/member/group/members`;

    this.sidebarService.performSearch(url, { search: searchTerm }).subscribe({
      next: (data: any) => {
        this.teamMembersLists = data || [];
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
      },
    });
  }

  selectedBrandId: any;

  onThemeChange(event: any) {
    this.sidebarService.selectedBusinessTheme = event?.value;
    this.sidebarService.wpData.theme_id = event?.value?.theme_id;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  onTeamChange(event: any) {
    this.wpDashboardTeamMembers.emit(event?.value)
    this.sidebarService.selectedMember = event?.value;
    this.sidebarService.wpData.member_id = event?.value?.user_id;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  onWPDashboardTeamChange(event: any){
    this.wpDashboardTeamMembers.emit(event?.value)
    this.sidebarService.selectedMember = event?.value;
    this.sidebarService.wpData.member_id = event?.value?.user_id;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  onUserTypeChange(event: any) {
    this.sidebarService.selectedUserType = event?.value;
    this.sidebarService.wpData.user_type = event?.value?.key;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  onStatusChange(event: any) {
    this.sidebarService.selectedStatus = event?.value;
    this.sidebarService.wpData.status = event?.value?.key;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  onIndicationChange(event: any) {
    this.sidebarService.selectedIndication = event?.value;
    this.sidebarService.wpData.indication = event?.value?.indication_id;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  // on task fiter
  onTaskThemeChange(event: any) {
    this.sidebarService.selectedTaskThemeId = event?.value;
    this.sidebarService.myTasksData.theme_id = event?.value?.theme_id;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
  }

  onTypeWorkChange(event: any) {
    this.sidebarService.selectedTaskType = event?.value;
    this.sidebarService.myTasksData.type = event?.value?.label;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
  }

  quarterOutcomesChange(event: any) {
    this.sidebarService.selectedTaskStatus = event?.value;
    this.sidebarService.myTasksData.status = event?.value?.key;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
  }

  onTaskYearChange(event: any) {
    this.sidebarService.selectedTaskYear = event?.value;
    this.sidebarService.myTasksData.year = event?.value?.key;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
    this.currentYear = event?.value?.key;
    this.quarterList(this.selectedRole);
    this.fetchThemeListBasedOnYear(event?.value?.key);
  }

  onQuarterChange(event: any) {
    this.sidebarService.selectedTaskQuarter = event?.value;
    this.sidebarService.myTasksData.quarter =
      event?.value?.quarter || event?.value;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
  }

  onUntouchedQuarterOutcomeChange(event: any) {
    this.sidebarService.selectedTaskUntouched = event?.value;
    this.sidebarService.myTasksData.untouched = event?.value;
    this.myTaskSelection.emit(this.sidebarService.myTasksData);
  }

  // dependecies
  onDependeciesQuarterChange(event: any) {
    this.sidebarService.selectedDependenciesQuarter = event?.value;
    this.sidebarService.dependencies.quarter = event?.value;
    this.dependeciesSelection.emit(this.sidebarService.dependencies);
  }

  GroupsIds: any = [];

  // outcomes
  onOutcomeUntouchedQuarterOutcomeChange(event: any) {
    this.sidebarService.selectedOutcomeUntouched = event?.value;
    this.sidebarService.outcomeData.untouched_outcome = event?.value;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }

  onAffiliateOutcomeChange(event: any) {
    this.sidebarService.is_affiliate = event?.value;
    this.sidebarService.outcomeData.is_affiliate = event?.value;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }

  onOutcomeAnnual(event: any) {
    this.sidebarService.selectedOutcomeAnnualOutcomeStatus = event?.value;
    this.sidebarService.outcomeData.outcome_status = event?.value?.key;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }

  onOutcomesRolesChange(event: any) {
    this.sidebarService.selectedOutcomeRoles = event?.value;
    this.sidebarService.outcomeData.role = event?.value?.name;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }

  onOutcomeTeamChange(event: any) {
    this.onOutcomeTeamberSearch.emit(event?.value)
    this.sidebarService.selectedOutcomeMembers = event?.value;
    this.sidebarService.outcomeData.group_members = event?.value?.user_id;
    this.GroupsIds.push(event?.value?.group_id);
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }
  onOutcomeSubgroups(event: any) {
    this.sidebarService.selectedOutcomeSubgroup = event?.value;
    this.subParentId = event?.value?.group_id;
    this.sidebarService.outcomeData.outcome_groups = event?.value?.group_id;
    this.sidebarService.outcomeData.parent_group = event?.value?.group_id;;
    this.onsubGroupMemberLists('outcome');
    
  }

  onsubGroupMemberLists(type?: any,isLoaded=false) {
    if (type == 'progressDashboard') {
      this.parentIds = this.sidebarService?.dashboardData?.parent_group;
      this.subParentId = this.sidebarService?.dashboardData?.outcome_groups;
      this.progressDashboardGroupIds = [];
      if (this.progressDashboardParentId) {
        this.progressDashboardGroupIds.push(this.progressDashboardParentId);
      }

      if (this.progressDashboardSubGroupId) {
        this.progressDashboardGroupIds.push(this.progressDashboardSubGroupId);
      }
      this.progressDashboardGroupIds = [
        ...new Set(this.progressDashboardGroupIds),
      ];
      this.httpService
        .post(
          `${environment.opbBackendHost}/api/${this.selectedRole}/group/members`,
          {
            groups: this.subParentId ? this.subParentId : this.parentIds,
          }
        )
        .subscribe((res: any) => {
          this.teamMembersData = res?.data;
          this.progressDashTeamMembers=res.data
        });
    } else {
      this.parentIds = this.sidebarService?.outcomeData?.parent_group;
      this.subParentId = this.sidebarService?.outcomeData?.outcome_groups;
      this.httpService
        .post(
          `${environment.opbBackendHost}/api/${this.selectedRole}/group/members`,
          {
            groups: this.subParentId ? this.subParentId : this.parentIds,
          }
        )
        .subscribe((res: any) => {
          this.teamMembersData = res?.data;
          if(isLoaded){
            const foundMember= this.teamMembersData.find((m:any) => m.user_id === this.helper.loggedInUser.user_id);
            this.sidebarService.selectedOutcomeMembers=foundMember
            this.outcomeSelection.emit(this.sidebarService.outcomeData)
          }

          if(type=='outcome'){
            this.outcomeTeamMembers=res?.data;
            const exists = this.outcomeTeamMembers?.some((member) => 
              member?.user_id === this.sidebarService.selectedOutcomeMembers?.user_id
            );

            if(!exists){
              this.sidebarService.selectedOutcomeMembers=null
              this.sidebarService.outcomeData.group_members=''
            }

            this.outcomeSelection.emit(this.sidebarService.outcomeData);
            
          }
        });
    }
  }

  onProgressDashboardStatusClear(){
    this.sidebarService.dashboardData.outcome_status=''
  }

  clearSubGroup() {
    this.sidebarService.dashboardData.outcome_groups =  
    this.sidebarService.dashboardData.parent_group
    this.sidebarService.selectedProgressDashboardGroup?.link == 'parent';
    this.sidebarService.selectedProgressDashboardMembers=null
    this.sidebarService.dashboardData.group_members=''
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  onClearProgressDashGroup(){
    this.sidebarService.selectedProgressDashboardSubgroup=null
    this.sidebarService.selectedProgressDashboardMembers=null
    this.sidebarService.dashboardData.group_members=''
  }

  clearOutcomeSubGroup() {
    this.sidebarService.outcomeData.outcome_groups =
      this.sidebarService.selectedOutcomeGroup?.group_id;
    this.GroupsIds = [];
    this.sidebarService.selectedOutcomeMembers=null
    this.sidebarService.outcomeData.parent_group = '';
    this.subParentId = null;
  }

  clearOutcomeGroup() {
    this.sidebarService.outcomeData.outcome_groups = '';
    this.sidebarService.outcomeData.parent_group = '';
    this.sidebarService.outcomeData.group_members = '';
    this.sidebarService.selectedOutcomeSubgroup = null;
    this.sidebarService.selectedOutcomeMembers = null;
    this.parentIds = null;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
    this.onParentStandaloneGroupSearch();
  }

  onOutcoMemberSearch(event: any) {
    const searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/${this.selectedRole}/group/members`;
    let include_member = '';
    if(this.selectedRole == 'iel') {
      include_member = this.helper.loggedInUser.user_id;
    }
    this.sidebarService
      .performSearch(url, {
        search: searchTerm,
        groups: this.subParentId ? this.subParentId : this.parentIds,
        include_members: include_member
      })
      .subscribe({
        next: (data: any) => {
          this.outcomeTeamMembers = data || [];
          // this.onOutcomeTeamberSearch.emit(data)
        },
        error: (err: any) => {
          console.error('Error fetching data:', err);
        },
      });
  }
  clearSearch() {
    this.GroupsIds = [];
  }

  onOutcomeYearChange(event: any) {
    this.sidebarService.selectedOutcomeYear = event?.value;
    this.sidebarService.outcomeData.outcome_year = event?.value?.value;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
    this.sidebarService.selectedOutcomeBusinessTheme = null;
    this.fetchThemeListBasedOnYear(event?.value?.value);
  }

  onDependenciesYearChange(event: any) {
    this.sidebarService.selectedDependenciesYear = event?.value;
    this.sidebarService.dependencies.outcome_year = event?.value?.value;
    this.dependeciesSelection.emit(this.sidebarService.dependencies);
    this.getQuarterListByYear(this.selectedRole, event?.value?.value || event?.value);
  }

  onProgressDashboardYearChange(event: any) {
    this.sidebarService.selectedProgressDashboardYear = event?.value;
    this.sidebarService.dashboardData.outcome_year = event?.value?.value;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
    this.sidebarService.selectedProgressDashboardBusinessTheme = null;
    this.getQuarterListByYear(this.selectedRole, event?.value?.value);
    this.fetchThemeListBasedOnYear(event?.value?.value);
  }

  fetchThemeListBasedOnYear(year: any) {
    this.helper.fetchThemeListBasedOnYear(year).subscribe((res: any) => {
      this.businessThemeLists = res?.data;
    });
    // this.httpService.post(`${environment.opbBackendHost}/api/member/themes`, {year:year}).subscribe((res: any) => {
    //   this.businessThemeLists = res?.data;
    // });
  }

  onOutcomeGroups(event: any) {
    this.sidebarService.selectedOutcomeGroup = event?.value;
    this.sidebarService.outcomeData.outcome_groups =
      event?.value?.group_id || '';
    this.parentIds = this.sidebarService.outcomeData.outcome_groups;
    // this.outcomeSelection.emit(this.sidebarService.outcomeData);
    // this.sidebarService.outcomeData.parent_group = event?.value?.group_id;
    this.sidebarService.selectedOutcomeSubgroup=null
    this.sidebarService.selectedOutcomeMembers=null
    if(this.sidebarService.selectedOutcomeGroup?.link!='parent'){
      this.sidebarService.outcomeData.parent_group=''
    }
    this.fetchSubgroupListData(this.sidebarService.outcomeData.outcome_groups);
    this.onsubGroupMemberLists('outcome');
  }
  onOutcomeTaskThemeChange(event: any) {
    this.sidebarService.selectedOutcomeBusinessTheme = event?.value;
    this.sidebarService.outcomeData.outcome_themes = event?.value?.theme_id;
    this.outcomeSelection.emit(this.sidebarService.outcomeData);
  }

  fetchSubgroupListData(parentIds: any,isHome=false,isOutcome=false) {
    this.helper.getSubgroupListData(this.selectedRole,parentIds,isHome)
      .subscribe((res: any) => {
        this.selectSubGroupsData = [...res?.data];
        this.selectOutcomeSubGroupsData=res?.data 
        this.selectProgressDashSubGroupsData=res?.data
        // this.onelectOutcomeSubGroupsData.emit(res?.data)
        if(isOutcome){
          this.sidebarService.outcomeData.outcome_groups= this.selectSubGroupsData[0]?.group_id || ''
          this.sidebarService.outcomeData.group_members= this.helper.loggedInUser.user_id
          if(this.sidebarService.selectedOutcomeSubgroup== null){
            this.sidebarService.selectedOutcomeSubgroup = this.selectSubGroupsData[0]
            this.outcomeSelection.emit(this.sidebarService.outcomeData)
          }
        return
        }
        // this.sidebarService.dashboardData.outcome_groups= this.selectSubGroupsData[0]?.group_id || ''
        // this.sidebarService.selectedProgressDashboardSubgroup = this.selectSubGroupsData[0]
        this.progressDashboardSelection.emit(this.sidebarService.dashboardData)
      });
  }

  loadSubgroupOutcomeListData(parentIds: any) {
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/${this.selectedRole}/child/groups`,
        {
          parents: String(parentIds),
        }
      )
      .subscribe((res: any) => {
        this.selectSubGroupsOutcomeData = [...res?.data];
      });
  }
  onsubGroupSearch(event: any) {
    const searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/${this.selectedRole}/child/groups`;

    this.sidebarService
      .performSearch(url, {
        search: searchTerm,
        parents: String(this.parentIds),
      })
      .subscribe({
        next: (data: any) => {
          this.selectSubGroupsData = data || [];
        },
        error: (err: any) => {
          console.error('Error fetching data:', err);
        },
      });
  }

  // on dashboard
  onProgressDashboardAnnual(event: any) {
    this.sidebarService.selectedProgressDashboardoutcome_status = event?.value;
    this.sidebarService.dashboardData.outcome_status = event?.value?.key;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  onProgressDashboardRolesChange(event: any) {
    this.sidebarService.selectedProgressDashboardRoles = event?.value;
    this.sidebarService.dashboardData.role = event?.value?.name;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  onProgressDashboardTeamChange(event: any) {
    this.onProgressTeamMemeber.emit(event?.value)
    this.sidebarService.selectedProgressDashboardMembers = event?.value;
    this.sidebarService.dashboardData.group_members = event?.value?.user_id;
    this.GroupsIds.push(event?.value?.group_id);
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }
  onProgressDashboardSubgroups(event: any) {
    this.sidebarService.selectedProgressDashboardSubgroup = event?.value;
    this.progressDashboardSubGroupId = event?.value?.group_id;
    this.sidebarService.dashboardData.outcome_groups = event?.value?.group_id;
    this.sidebarService.selectedProgressDashboardMembers=null
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
    this.onsubGroupMemberLists('progressDashboard');
  }

  onProgressDashboardGroupSearch(event:any){
    const searchTerm = event?.filter || '';
    const url = `${environment.opbBackendHost}/api/${this.selectedRole}/parent/groups`;

    this.sidebarService.performSearch(url, { search: searchTerm }).subscribe({
      next: (data: any) => {
        this.selectProgressDashSubGroupsData = data || [];
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
      },
    });
  }

  onOutcomeGroupsP(event: any) {
    this.sidebarService.selectedProgressDashboardGroup = event?.value;
    this.sidebarService.dashboardData.outcome_groups =
      event?.value?.group_id || '';
    this.parentIds = this.sidebarService.dashboardData.outcome_groups;
    // this.outcomeSelection.emit(this.sidebarService.outcomeData);
    // this.sidebarService.outcomeData.parent_group = event?.value?.group_id;
    this.sidebarService.selectedProgressDashboardSubgroup=null
    this.sidebarService.selectedProgressDashboardMembers=null
    if(this.sidebarService.selectedProgressDashboardGroup?.link!='parent'){
      // this.sidebarService.dashboardData.parent_group=''
    }
    this.fetchSubgroupListData(this.sidebarService.dashboardData.outcome_groups);
    this.onsubGroupMemberLists('progressDashboard');
  }

  onClearTeamProgressDash(){
    this.sidebarService.dashboardData.group_members=''
  }

  onProgressDashboardGroups(event: any) {
    if(event.value.link != 'parent'){
      this.sidebarService.selectedProgressDashboardSubgroup=null
    }
    if(this.sidebarService.selectedProgressDashboardSubgroup){
    this.sidebarService.dashboardData.outcome_groups = this.sidebarService.selectedProgressDashboardSubgroup?.group_id;
    }else{
      this.sidebarService.dashboardData.outcome_groups = event?.value?.group_id;
    }
    this.sidebarService.selectedProgressDashboardGroup = event?.value;
    this.progressDashboardParentId = event?.value?.group_id;
    this.sidebarService.dashboardData.parent_group = event?.value?.group_id;
    if(event.value.link == 'parent'){
      this.fetchSubgroupListData(
        this.sidebarService.dashboardData.outcome_groups,true
      );
    }else{
      this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
    }
    // this.sidebarService.selectedProgressDashboardSubgroup = null;
    this.onsubGroupMemberLists('progressDashboard');
  }
  onProgressDashboardThemeChange(event: any) {
    this.sidebarService.selectedProgressDashboardBusinessTheme = event?.value;
    this.sidebarService.dashboardData.outcome_themes = event?.value?.theme_id;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  constructor() {}
  selectedRole: any;
  ngOnInit(): void {
    this.sidebarService.outcomeData.is_affiliate = 'no';
    if (this.sidebarService.selectedOutcomeYear == null && this.isOutcome) {
      this.sidebarService.selectedOutcomeYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
      this.sidebarService.outcomeData.outcome_year = new Date().getFullYear();
    }
    if (this.sidebarService.selectedWPYear == null && this.isWPSidebar) {
      this.sidebarService.selectedWPYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
    }

    if (this.sidebarService.selectedDependenciesYear == null && this.isDependecies) {
      this.sidebarService.selectedDependenciesYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
    }

    
    
    if (this.sidebarService.selectedTaskYear == null && this.isTask) {
      this.sidebarService.selectedTaskYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
      this.sidebarService.myTasksData.year = new Date().getFullYear();
    }

    if (this.sidebarService.selectedHomeYear == null && this.isHomeSidebar) {
      this.sidebarService.selectedHomeYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
      this.sidebarService.homeData.outcome_year = new Date().getFullYear();
    }

    if (
      this.sidebarService.selectedProgressDashboardYear == null &&
      this.isDashboard
    ) {
      this.sidebarService.selectedProgressDashboardYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
    }

    this.outcomeYear = this.helper.generateYearArray(2022);
    this.roleSubscription = this.apiService.role$.subscribe((role) => {
      this.selectedRole = role;
    });

    this.brandListSubs = this.helper.brandList$.subscribe((data: any) => {
      this.brandLists = data;
    });
    this.themeListSubs = this.helper.themeList$.subscribe((data: any) => {
      this.businessThemeLists = data;
    });
    this.memberListSubs = this.helper.memberList$.subscribe((data: any) => {
      this.teamMembersLists = data;
    });

    this.overAllGroupsSubs = this.helper.parentStandaloneGroupList$.subscribe(
      (data: any) => {
        this.parentStandaloneGroupListData = data;
      }
    );

    if (this.sidebarService.selectedBrand?.brand_id) {
      this.selectedBrandId = this.sidebarService.selectedBrand?.brand_id;
      this.getTherapeuticList(this.sidebarService.selectedBrand?.brand_id);
    }
    if (this.sidebarService.selectedTherapeuticArea?.therapeutic_area_id) {
      this.getIndicationsList(
        this.sidebarService.selectedTherapeuticArea?.therapeutic_area_id
      );
    }

    this.quaterSubscription = this.apiService.quarter$.subscribe((data) => {
      this.selectedQuater = data;
      this.sidebarService.homeData.outcome_quarters = data;
      this.sidebarService.myTasksData.quarter = data;
      this.sidebarService.selectedTaskQuarter = data;
      // this.sidebarService.homeData.outcome_year = new Date().getFullYear();
      this.sidebarService.dashboardData.outcome_quarters = data;
      this.sidebarService.dependencies.quarter = data;
      if (!this.sidebarService.selectedHomeQuarter) {
        this.sidebarService.selectedHomeQuarter = data;
      }

      if (this.sidebarService.selectedTaskYear?.value) {
        this.fetchThemeListBasedOnYear(
          this.sidebarService.selectedTaskYear?.value
        );
      }
      if (this.sidebarService.selectedProgressDashboardYear?.value) {
        this.getQuarterListByYear(
          this.selectedRole,
          this.sidebarService.selectedProgressDashboardYear.value
        );
        this.fetchThemeListBasedOnYear(
          this.sidebarService.selectedProgressDashboardYear?.value
        );
      }

      if (this.sidebarService.selectedOutcomeYear?.value) {
        this.fetchThemeListBasedOnYear(
          this.sidebarService.selectedOutcomeYear?.value
        );
      }

      if (this.sidebarService.selectedWPYear?.value) {
        this.fetchThemeListBasedOnYear(
          this.sidebarService.selectedWPYear?.value
        );
      }

      this.sidebarService.selectedDependenciesQuarter = data;
      this.dependeciesSelection.emit(this.sidebarService.dependencies);
      // this.homeSelection.emit(this.sidebarService.homeData);
      this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
    });

    this.currentYear = this.sidebarService.selectedTaskYear?.value;
    if (this.sidebarService.selectedHomeYear?.value) {
      this.getQuarterListByYear(
        this.selectedRole,
        this.sidebarService.selectedHomeYear.value
      );
      this.fetchThemeListBasedOnYear(
        this.sidebarService.selectedHomeYear.value
      );
    }

  }

  setDefaultTheme() {
    const defaultTheme = this.businessThemeLists.find(
      (theme: Theme) => theme.theme_id === this.currentTheme
    );

    if (!defaultTheme) {
      this.currentTheme = this.currentTheme;
    }
  }

  closeSidebar() {
    this.close.emit();
  }

  onHomeYearChange(event: any) {
    this.sidebarService.selectedHomeYear = event?.value;
    this.sidebarService.homeData.outcome_year = event?.value?.key;
    this.sidebarService.selectedHomeThemeId = null;
    this.sidebarService.homeData.outcome_themes = '';
    this.homeSelection.emit(this.sidebarService.homeData);
    this.getQuarterListByYear(this.selectedRole, event?.value?.key || event?.value);
    this.fetchThemeListBasedOnYear(event?.value?.key || event?.value);
  }

  onWPYearChange(event: any) {
    this.sidebarService.selectedWPYear = event?.value;
    this.sidebarService.selectedBusinessTheme = null;
    this.fetchThemeListBasedOnYear(event?.value?.key);
  }

  onBrandChange(event: any) {
    this.sidebarService.selectedBrand = event?.value;
    this.sidebarService.selectedTherapeuticArea=null
    this.sidebarService.selectedIndication=null
    this.selectedBrandId = event.value?.brand_id;
    this.sidebarService.wpData.brand_id = event?.value?.brand_id;
    this.sidebarService.wpData.therapeutic_area=''
    this.sidebarService.wpData.indication=''
    this.dropdownSelection.emit(this.sidebarService.wpData);
    if (this.selectedBrandId) {
      this.getTherapeuticList(this.selectedBrandId);
    }
  }

  onBrandClear(){
    this.sidebarService.wpData.brand_id=''
  }

  onTherapeuticAreaChange(event: any) {
    const selectedTherapeuticData = event.value?.therapeutic_area_id;
    if (selectedTherapeuticData) {
      this.getIndicationsList(selectedTherapeuticData);
    }
    this.sidebarService.selectedIndication=null
    this.sidebarService.wpData.indication=''
    this.sidebarService.wpData.therapeutic_area_id =
      event?.value?.therapeutic_area_id;
    this.sidebarService.selectedTherapeuticArea = event?.value;
    this.dropdownSelection.emit(this.sidebarService.wpData);
  }

  getTherapeuticList(brandId: string) {
    let data = {
      brand_id: brandId,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/workpackage/therapeutic/areas`,
        data
      )
      .subscribe((res: any) => {
        this.therapeuticAreaLists = res?.data;
      });
  }

  getIndicationsList(therapiId: string) {
    let data = {
      brand_id: this.selectedBrandId,
      therapeutic_area_id: therapiId,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/workpackage/indications`,
        data
      )
      .subscribe((res: any) => {
        this.IndicationLists = res?.data;
      });
  }

  getQuarterListByYear(cat: any, year: any) {
    this.helper
      .fetchquarterListBasedOnYear(cat, year)
      .subscribe((data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      });
  }

  quarterList(cat: string) {
    const data = {
      year: this.currentYear,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  groupList(cat: string) {
    const groupPayload = { type: 'all', link: 'all' };

    this.groupService.getGroup(groupPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.groupListItem = parsedData['data']['chapter']['standalone'];
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching groups', error);
      }
    );
  }

  onProgressDasboardQuarterFilterChange(data: any) {
    this.apiService.setQuarter(data);
    this.sidebarService.dashboardData.quarter = data;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  onQuarterFilterChange(event: any) {
    // this.apiService.setQuarter(data);
    this.sidebarService.selectedHomeQuarter = event.value;
    this.sidebarService.homeData.outcome_quarters = event.value;
    this.homeSelection.emit(this.sidebarService.homeData);
  }

  onProgressDashboardQuarterFilterChange(data: any) {
    this.selectedQuater = data;
    this.sidebarService.dashboardData.outcome_quarters = data;
    this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
  }

  onGroupFilterChange(data: any) {
    this.apiService.setGroup(data?.value?.user_id);
  }

  onThemeFilterChange(event: any) {
    // this.apiService.setTheme(data);
    this.sidebarService.selectedHomeThemeId = event;
    this.sidebarService.homeData.outcome_themes = event;
    this.homeSelection.emit(this.sidebarService.homeData);
  }

  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    this.overAllGroupsSubs?.unsubscribe();
  }
}
